import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import Gallery from "./components/gallery";
import ReviewsSlider from "./components/reviews-slider";
import InspirationsSlider from "./components/inspirations-slider";
import ProductsSlider from "./components/products-slider";
import ScrollInView from "./components/scroll-in-view";
import {bindProductQuantityInput} from "./components/product-quantity-input";

import DeviceManager from "./utils/device-manager";

import '../js/components/back-to-top';

// (function ($) {
	// window.$ = $;

$(function () {

	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	}
	
	const instanciateComponents = () => {
		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);

		// Home slider component
		const $homesSliders = $(".homepage-slider");
		if ($homesSliders.length) {
			$homesSliders.each(function (index, el) {
				const homeSlider = new HomeSlider($(el));
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Products slider component
		const $productsSliders = $(".home-products .products-slider");
		if ($productsSliders.length) {
			$productsSliders.each(function (index, el) {
				const productsSlider = new ProductsSlider($(el));
			});
		}

		// Inspirations slider component
		const $inspirationsSliders = $(".home-inspirations .inspirations");
		if ($inspirationsSliders.length) {
			$inspirationsSliders.each(function (index, el) {
				const inspirationsSlider = new InspirationsSlider($(el));
			});
		}

		// Reviews slider component
		const $reviewsSliders = $(".home-reviews .reviews");
		if ($reviewsSliders.length) {
			$reviewsSliders.each(function (index, el) {
				const reviewsSlider = new ReviewsSlider($(el));
			});
		}


		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}

		// Product quantity input component
		const isProductPage = $('body').hasClass('single-product');
		if (isProductPage) {
			bindProductQuantityInput();
		}
	}

	bootstrapApp();
	instanciateComponents();

});

// })(jQuery);
